import { styled } from "@mui/material";
import { exProps } from "../../utils/mui";

export const Container = styled('div')(({ theme }) => ({
  flexGrow: 1, 
  overflow: "hidden",
  flexShrink: 0
}))

export const Table = styled('div')(({ theme }) => ({
  ".MuiTableCell-root": { 
    paddingTop: 0,
    paddingBottom: 0, 
    flexBasis: "50px", 
    display: "flex", 
    justifyContent: "flex-start", 
    alignItems: "center" 
  }, 
  ".MuiTableRow-root": { 
    display: "flex" 
  },
  display: "flex",
  flexDirection: "column",
  alignItems: "stretch",

  '.list': {
    '::-webkit-scrollbar': {
      width: 10
    },
    '::-webkit-scrollbar-track': {
      backgroundColor: 'rgba(0, 0, 0, 0.05)',
      border: '2px solid white',
      borderRadius: 5
    },
    '::-webkit-scrollbar-thumb': {
      backgroundColor: 'rgba(0, 0, 0, 0.2)',
      border: '2px solid white',
      borderRadius: 5
    }
  }
}))

export const TableCell = styled('div', exProps("selected", "edit", "disabled"))
  <{ selected?: boolean, edit?: boolean, disabled?: boolean }>(({ selected, edit, theme, disabled }) => ({
  ...(selected && !edit) && {
    boxShadow: `inset 0 0 0 2px ${theme.palette.primary.main}`
  },
  paddingLeft: theme.spacing(2),
  paddingRight: theme.spacing(2),
  ...edit && {
    padding: 0
  },
  borderBottom: `1px solid ${theme.palette.grey[200]}`,
  display: "flex",
  alignItems: "center",
  boxSizing: "border-box",
  ...disabled && {
    color: theme.palette.text.disabled
  },

  "input": {
    flex: "1 1 auto",
    alignSelf: "stretch",
    width: 0,
    paddingLeft: theme.spacing(1.75),
    paddingRight: theme.spacing(1.75),
    outline: "none",
    border: `2px solid ${theme.palette.primary.main}`,
    fontSize: "1em",
    fontFamily: theme.typography.fontFamily
  }
}))
